function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.66897 .7433 -.66897 .7433 0 1)",
  stroke: "#747474",
  strokeLinecap: "round",
  d: "M.5-.5h12.454"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(-.66897 .7433 .66897 .7433 18 1)",
  stroke: "#747474",
  strokeLinecap: "round",
  d: "M.5-.5h12.454"
});

function SvgArrowDowninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgArrowDowninline;